/**
 * Feature code normally reads instance capabilities. Keep deliberate slug
 * checks here when a partner-specific experience must not spread, such as
 * McGraw Hill's catalog.
 */
export const INSTANCE_SLUGS = {
  mcgrawHill: 'mcgraw-hill',
  beal: 'beal',
  byu: 'byu',
} as const;
